core.directive('edmMdDataGrid', ['$parse', '$translate',
    function($parse, $translate) {
        var definition = {
            restrict: 'E',
            replace: true,
            scope: {
                titleText: '@?',
                buttons: '=',
                filters: '=?',
                columnsInline: '@',
                showSearch: '@',
                columns: '=?',
                data: '=',
                numberOfPages: '=',
                criteria: '=?',
                showPaging: '@',
                onCriteriaChanged: '&',
                onRowClicked: '&',
                placeholder: '@?',
                elementsPerPage: '@?',
                hidePaging: '@?',
                hideSearchBox : '@?',
                markDeletedField : '@?',
                markReadField: '@?'
            },
            templateUrl: 'core/application/directive/edmMdDataGrid/template/edm-md-data-grid.html',
            compile: function (element, attr) {
                if(attr.multiSelect) {
                    element.find('table').attr('md-row-select', 'selected');
                }

                return function($scope, element, attr) {
                    $scope.Enum = Enum;

                    $scope.translatedElementsPerPage = $scope.elementsPerPage ? $translate.instant($scope.elementsPerPage) : $translate.instant('T.MODULE.PATIENT.ELEMENTS_PER_PAGE');
                    $scope.placeholder = $scope.placeholder ? $scope.placeholder : 'T.MODULE.PATIENT.INSERT_FIRST_OR_LAST_NAME_OR_IDENTIFIER';
                    $scope.hidePaging = $scope.hidePaging ?  JSON.parse($scope.hidePaging) : false;
                    $scope.hideSearchBox = $scope.hideSearchBox ? JSON.parse($scope.hideSearchBox) : false;

                    if($scope.columnsInline) {
                        $scope.columns = $scope.$eval($scope.columnsInline);
                    }

                    if($scope.showSearch) {
                        $scope._showSearch = $scope.$eval($scope.showSearch);
                    } else {
                        $scope._showSearch = true;
                    }

                    if($scope.showPaging) {
                        $scope.showPaging = $scope.$eval($scope.showPaging);
                        $scope.$watch('numberOfPages', function (newVal) {
                            $scope.pagesArray = new Array(newVal);
                        });
                    }

                    $scope.currentPage = 1;
                    $scope.rowsPerSheet = 20;

                    $scope.$watch('sorting', function (newVal) {
                        if(newVal && $scope.criteria) {
                            //$scope.criteria.sorting = { columnName: $scope.columns[Math.abs(newVal)].sorting, descending: false };
                            //if(newVal.indexOf('-') === 0) {
                            //    $scope.criteria.sorting.descending = true;
                            //}
                            var index = _.findIndex($scope.criteria.sortColumns, function(column){
                                return column.columnName == $scope.columns[Math.abs(newVal)].field
                            });
                            if(index > -1) {
                                $scope.criteria.sortColumns[index].descending = !$scope.criteria.sortColumns[index].descending;
                            } else {
                                $scope.criteria.sortColumns = [{
                                    columnName: $scope.columns[Math.abs(newVal)].field,
                                    descending: newVal.indexOf('-') === 0
                                }];
                                // $scope.criteria.sortColumns.push({
                                //    columnName: $scope.columns[Math.abs(newVal)].field,
                                //    descending: newVal.indexOf('-') === 0
                                //});
                            }

                            $scope._onCriteriaChanged();
                        }
                    });

                    var disabler = $scope.$watch('criteria', function (newVal) {
                        if(newVal) {
                            $scope.currentPage = newVal.pageNumber + 1;
                            $scope.rowsPerSheet = newVal.rowsPerSheet;
                            disabler();
                        }
                    });


                    var width = element.parent().width() - 30;
                    var sum = 0;
                    var columnsWithoutWidth = 0;

                    $scope.columns.forEach(function (column) {
                        if(!_.isUndefined(column.width)) {
                            if(!isNaN(parseFloat(column.width)) && isFinite(column.width)) {
                                sum += column.width;
                                column.width = column.width + 'px';
                            }
                        } else {
                            columnsWithoutWidth++;
                        }
                    });

                    var widthToFill = width - sum;

                    $scope.columns.forEach(function (column) {
                        if(_.isUndefined(column.width)) {
                            column.width = (widthToFill / columnsWithoutWidth) + 'px';
                        }
                    });

                    $scope.getValue = function (row, column) {
                        var value = null;
                        var getter = $parse(column.field);
                        return getter(row);
                    };

                    $scope.rowAction = function(a,b) {
                        return $scope.$parent[a](b);
                    };

                    $scope.parentAction = function (a, args) {
                        return $scope.$parent[a].apply(this, Array.prototype.slice.call(arguments, 1));
                    };

                    $scope.goToPage = function (index) {
                        $scope.criteria.pageNumber = index;
                        $scope.onCriteriaChanged();
                    };

                    $scope.getTotal = function () {
                        return $scope.numberOfPages * $scope.criteria.rowsPerSheet;
                    };

                    $scope._onSearchPhraseChanged = function () {
                        $scope.currentPage = 1;
                        $scope._onCriteriaChanged();
                    };

                    $scope._onFilterChanged = function (fieldName, value) {
                        $scope.criteria[fieldName] = value;
                        $scope.currentPage = 1;
                        $scope._onCriteriaChanged();
                    };

                    $scope._onCriteriaChanged = function () {
                        if($scope.rowsPerSheet != $scope.criteria.rowsPerSheet) {
                            $scope.criteria.rowsPerSheet = $scope.rowsPerSheet;
                            $scope.currentPage = 1;
                        }
                        $scope.criteria.pageNumber = $scope.currentPage - 1;
                        $scope.onCriteriaChanged();
                    };

                    $scope.onButtonClick = function (button) {
                        $scope.$parent[button.action]();
                    };

                    $scope.className = function(button) {
                        if(button.buttonClass) {
                            var classes = button.buttonClass.join(' ');
                            return classes;
                        }
                    }


                }
            }
        };

        return definition;
    }
]);